/**
 * Get the containing element for calculating position.
 */
import getCommonOffsetContainer from "./getCommonOffsetContainer"
import { getWindow, isHtmlElement } from "../utils"

const getContainer = (element: Element, otherElement: Element) => {
  const offsetParent = getCommonOffsetContainer(element, otherElement)
  return isHtmlElement(offsetParent)
    ? getWindow(element).document.documentElement
    : offsetParent
}

export default getContainer
